import { render, staticRenderFns } from "./ToggleSwitch.vue?vue&type=template&id=0480ee36&scoped=true&"
import script from "./ToggleSwitch.vue?vue&type=script&lang=js&"
export * from "./ToggleSwitch.vue?vue&type=script&lang=js&"
import style0 from "./ToggleSwitch.vue?vue&type=style&index=0&id=0480ee36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0480ee36",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
